<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="fechar()">
  Histórico de compras · {{ data.productName }}
</aionz-header-bottom-sheet>

<aionz-dialog-content class="historico">
  @switch (estado().tipo) {
    @case ('carregando') {
      <div
        class="historico-carregando"
        role="status"
        aria-label="Carregando o histórico de compras">
        <div class="skeleton historico-skeleton-resumo"></div>
        <div class="skeleton historico-skeleton-grafico"></div>
      </div>
    }
    @case ('erro') {
      <div
        class="historico-vazio"
        role="alert">
        <mat-icon aria-hidden="true">cloud_off</mat-icon>
        <p>Não foi possível carregar o histórico de compras deste produto.</p>
      </div>
    }
    @default {
      @if (pagina(); as pagina) {
        @if (pagina.demo) {
          <p
            class="historico-aviso"
            role="note">
            <mat-icon aria-hidden="true">science</mat-icon>
            Dados de exemplo: a rota do histórico completo ainda não existe no backend. Só aparece
            no localhost.
          </p>
        }

        @if (pagina.summary.count === 0) {
          <div class="historico-vazio">
            <mat-icon aria-hidden="true">history</mat-icon>
            <p>Ainda não há compras deste produto.</p>
          </div>
        } @else {
          <!-- Resumo -->
          <dl class="historico-resumo">
            <div class="historico-stat">
              <dt>Menor preço</dt>
              <dd class="historico-stat--sucesso">{{ pagina.summary.lowestPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}</dd>
            </div>
            <div class="historico-stat">
              <dt>Maior preço</dt>
              <dd>{{ pagina.summary.highestPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}</dd>
            </div>
            <div class="historico-stat">
              <dt>Preço médio</dt>
              <dd>{{ pagina.summary.averagePrice | currency: 'BRL' : 'symbol' : '1.2-2' }}</dd>
            </div>
            <div class="historico-stat">
              <dt>Quantidade média</dt>
              <dd>{{ pagina.summary.averageQuantity | number: '1.0-0' }} {{ data.unitLabel }}</dd>
            </div>
            @if (ultimoCorrigido(); as corrigido) {
              <div class="historico-stat">
                <dt>Último pago corrigido (IPCA)</dt>
                <dd>
                  {{ corrigido.valor | currency: 'BRL' : 'symbol' : '1.2-2' }}
                  <span class="historico-stat-nota">{{ corrigido.variacao | percent: '1.1-1' }} de IPCA</span>
                </dd>
              </div>
            }
            @if (cotadoVsMedia(); as cotado) {
              <div class="historico-stat">
                <dt>Menor cotado agora</dt>
                <dd>
                  {{ cotado.valor | currency: 'BRL' : 'symbol' : '1.2-2' }}
                  <span
                    class="historico-stat-nota"
                    [class.historico-stat-nota--acima]="cotado.diferenca > 0.005"
                    [class.historico-stat-nota--abaixo]="cotado.diferenca < -0.005">
                    {{ cotado.diferenca > 0 ? '+' : '' }}{{ cotado.diferenca | percent: '1.1-1' }} da média
                  </span>
                </dd>
              </div>
            }
          </dl>

          <!-- Variação do preço pago -->
          @if (pontos().length > 1) {
            <section
              class="historico-grafico"
              aria-labelledby="historico-grafico-titulo">
              <header class="historico-grafico-cabecalho">
                <h3 id="historico-grafico-titulo">Preço pago por {{ data.unitLabel }}</h3>
                <span class="historico-grafico-legenda">
                  <span
                    class="historico-legenda-media"
                    aria-hidden="true"></span>
                  Preço médio
                </span>
              </header>
              <div
                class="historico-grafico-area"
                (mouseleave)="pontoAtivo.set(null)">
                <svg
                  [attr.viewBox]="'0 0 ' + grafico.largura + ' ' + grafico.altura"
                  preserveAspectRatio="none"
                  role="img"
                  [attr.aria-label]="'Variação do preço pago nas últimas ' + pontos().length + ' compras. Os valores estão na tabela abaixo.'">
                  @if (yMedia(); as y) {
                    <line
                      class="historico-media"
                      [attr.x1]="0"
                      [attr.x2]="grafico.largura"
                      [attr.y1]="y"
                      [attr.y2]="y" />
                  }
                  <path
                    class="historico-linha"
                    [attr.d]="linha()" />
                  @for (ponto of pontos(); track $index) {
                    <!-- alvo de hover maior que a marca -->
                    <rect
                      class="historico-alvo"
                      [attr.x]="ponto.x - grafico.largura / pontos().length / 2"
                      [attr.width]="grafico.largura / pontos().length"
                      y="0"
                      [attr.height]="grafico.altura"
                      (mouseenter)="pontoAtivo.set(ponto)" />
                  }
                </svg>
                @if (pontoAtivo(); as ponto) {
                  <span
                    class="historico-marcador"
                    aria-hidden="true"
                    [style.left.%]="(ponto.x / grafico.largura) * 100"
                    [style.top.%]="(ponto.y / grafico.altura) * 100"></span>
                  <div
                    class="historico-dica"
                    [class.historico-dica--esquerda]="ponto.x > grafico.largura * 0.6"
                    [style.left.%]="(ponto.x / grafico.largura) * 100"
                    [style.top.%]="(ponto.y / grafico.altura) * 100">
                    <strong>{{ ponto.entry.unitPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}</strong>
                    <span>{{ ponto.entry.date | date: 'dd/MM/yyyy' }} · {{ ponto.entry.supplierName }}</span>
                    <span>{{ ponto.entry.quantity | number: '1.0-3' }} {{ ponto.entry.unit }}</span>
                  </div>
                }
              </div>
            </section>
          }

          <!-- Compras -->
          <section aria-label="Compras do produto">
            <table
              mat-table
              class="historico-tabela"
              [dataSource]="linhas()">
              <ng-container matColumnDef="date">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Data
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry">
                  {{ entry.date | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="supplier">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Fornecedor
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry"
                  class="historico-fornecedor">
                  {{ entry.supplierName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="historico-num">
                  Quantidade
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry"
                  class="historico-num">
                  {{ entry.quantity | number: '1.0-3' }} {{ entry.unit }}
                </td>
              </ng-container>
              <ng-container matColumnDef="unitPrice">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="historico-num">
                  Preço unit.
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry"
                  class="historico-num">
                  {{ entry.unitPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="vsAverage">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="historico-num">
                  vs. média
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry"
                  class="historico-num">
                  @let diferenca = diferencaDaMedia(entry.unitPrice);
                  @if (diferenca !== null) {
                    <span
                      [class.historico-acima]="diferenca > 0.005"
                      [class.historico-abaixo]="diferenca < -0.005">
                      {{ diferenca > 0 ? '+' : '' }}{{ diferenca | percent: '1.0-1' }}
                    </span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="origin">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Origem
                </th>
                <td
                  mat-cell
                  *matCellDef="let entry">
                  @if (entry.origin === 'erp') {
                    <span class="historico-origem">ERP</span>
                  } @else {
                    <span class="historico-origem historico-origem--cotai">
                      Cotai{{ entry.purchaseRequestId ? ' · #' + entry.purchaseRequestId : '' }}
                    </span>
                  }
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="colunas"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: colunas"></tr>
            </table>
            @if (pagina.entries.length > porPagina) {
              <mat-paginator
                [length]="pagina.entries.length"
                [pageSize]="porPagina"
                [pageIndex]="indicePagina()"
                [hidePageSize]="true"
                (page)="mudarPagina($event)" />
            }
          </section>
        }
      }
    }
  }
</aionz-dialog-content>

<aionz-dialog-actions align="end">
  <button
    matButton="outlined"
    type="button"
    (click)="fechar()">
    Fechar
  </button>
</aionz-dialog-actions>
